var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F5B866"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 29C11.45 29 10.9793 28.8043 10.588 28.413C10.1967 28.0217 10.0007 27.5507 10 27V16C10 15.45 10.196 14.9793 10.588 14.588C10.98 14.1967 11.4507 14.0007 12 14H16V12C16 11.45 16.196 10.9793 16.588 10.588C16.98 10.1967 17.4507 10.0007 18 10H22C22.55 10 23.021 10.196 23.413 10.588C23.805 10.98 24.0007 11.4507 24 12V14H28C28.55 14 29.021 14.196 29.413 14.588C29.805 14.98 30.0007 15.4507 30 16V27C30 27.55 29.8043 28.021 29.413 28.413C29.0217 28.805 28.5507 29.0007 28 29H12ZM18 14H22V12H18V14Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSettings);
export default __webpack_public_path__ + "static/media/total-settings.5e581d9c1602a460550df1879a7aeab1.svg";
export { ForwardRef as ReactComponent };